// 存储三方内购支付渠道pay_type

export default {
  client: {
    yyb: 22, // 应用宝内购
    ios: 7, // ios内购
    huawei4: 24, // 华为
    xiaomi: 25, // 小米
    jiuyou: 58, // 九游
    vivo: 60, // vivo
    huawei6: 61, // 新版华为
    oppo: 28, // oppo
    qh360: 35, // 360（V2.2.4）
    meizu: 31, // 魅族
    baidu: 37, // 百度
    lianxiang: 34, // 联想
    sanxing: 68, // 三星
    jinli: 33, // 金立
    coolpad: 32, // 酷派 
    douyu: 69, // 斗鱼
    game4399: 70, // 4399
    sogou: 71, // 搜狗
    treeAnt: 72, // 木蚂蚁
    yunyou: 73, //  云游
    bugBug: 74, // 虫虫助手
    SmallSeven: 75, //小七平台
    qtt: 77, // 趣头条
    hjy: 80, // 欢聚游
    hjy240: 82, // 欢聚游
    samsung: 83, // 新三星
    yuewen: 84, // 阅文
    xiaosb: 87,
    quick: 88,
    yami: 89,
    ks_xiaosb: 90,
    vm_mumu: 91,
    vm_thunder: 92,
    taptap: 95, // taptap 使用自己支付
    blackshark: 96, // 黑鲨
    ttTalk: 97,
    momoyu: 98,
    huya: 99,
    bilibili: 107,
    guopan: 109,  // 果盘
    gamefan: 110, // 游戏fan
    rongyao: 117, // 荣耀
  },
  h5: {
    yyb: 22, // 应用宝内购
    ios: 7, // ios内购
    huawei: 24, // 华为
    xiaomi: 25, // 小米
    oppo: 28, // oppo
    vivo: 29, // vivo
    uc: 30, // uc
    meizu: 31, // 魅族
    kupai: 32, // 酷派
    jinli: 33, // 金立
    lianxiang: 34, // 联想
    '360': 35, // 360
    baidu: 37, // 百度
    quick: 88,
    xiaosb: 87,
  },
  special: ['momoyu'], // 需要使用我们自己登录框的硬核渠道
}